import { Component, EventEmitter, Output } from '@angular/core';
import { COMPONENT_NAME } from '@app/constants/message.constants';
import { MessageAction } from '@app/models/message-action.model';
import { MessageComponent } from '@app/models/message-base.component';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent extends MessageComponent {
  @Output() onMessageAction = new EventEmitter<MessageAction>();
  override type = COMPONENT_NAME.LOADER
}